export default __webpack_public_path__ + "static/media/011-woodworking.99ba496d.svg";